export default "__VITE_ASSET__fb8a47cf__"